export default __webpack_public_path__ + "static/media/kitchen5-beforeD-1920w.c558fa1f.webp";